import React from 'react';
import PropTypes from 'prop-types';
import { Button, LinkButton } from '../../design-system/Buttons';

const DashboardButton = ({
  onClickUnlocked,
  onClickLocked,
  locked,
  children,
  ...rest
}) => (locked ? (
  <Button
    onClick={onClickLocked}
    center
    {...rest}
    className="ss_d--flex ss_row"
  >
    <span>{children}</span>
    {locked && (
    <img
      alt=""
      src="//images.ctfassets.net/gtqjh9j40j4m/4WO5NCipv57JHayFBCOaNB/fea23a35647236e4c4633e4a787d021b/profile-lock.svg"
      style={{
        alignSelf: 'center',
        height: '24px',
        paddingLeft: '8px',
        width: '32px',
      }}
    />
    )}
  </Button>
) : (
  <LinkButton
    onClick={onClickUnlocked}
    {...rest}
    center
    className="ss_d--flex"
  >
    {children}
  </LinkButton>
));

DashboardButton.propTypes = {
  children: PropTypes.node.isRequired,
  locked: PropTypes.bool,
  onClickUnlocked: PropTypes.func,
  onClickLocked: PropTypes.func,
};

DashboardButton.defaultProps = {
  locked: false,
  onClickUnlocked: undefined,
  onClickLocked: undefined,
};

export default DashboardButton;
